/**
 * Fetch one facet envelope and apply it only if it is still the newest.
 *
 * `api` is passed in by the caller rather than imported here, matching the
 * store's existing cache modules — the component owns the API client, the
 * store owns the sequencing.
 *
 * A stale response is dropped rather than applied: the endpoint echoes nothing
 * about the request, so the sequence number is the only thing that can tell a
 * slow answer for an old filter context from the current one.
 */
export async function fetch({ state, commit }, { params, api }) {
  const sequence = state.sequence + 1;
  commit("startRequest", sequence);

  try {
    const { data } = await api(params);

    if (state.sequence !== sequence) return;

    commit("applyFacet", data?.facets?.brands);
  } catch (error) {
    if (state.sequence !== sequence) return;

    commit("failFacet");
  }
}

export function reset({ commit }) {
  commit("reset");
}
